import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
Vue.use(VueRouter)

const routes = [
	{
		path:'/',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'index',
		component: index
	}
]

const router = new VueRouter({
  mode: 'history',
  base: '/tsddzznpro/',
  routes
})

export default router
